import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Version5Service {

  idEmpresa: string;
  idUsuario: string;
  nivel:number;
  userEmail:string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
  this.obtienInfo();
  }

  obtienInfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
    this.nivel = infoUsu.level;
    this.userEmail=infoUsu.user;
  }

  getURLCA2(){
    this.obtienInfo();
    let datos = {};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getURLCA2 + this.idUsuario, datos);
  }

  getURLCA2Version2(productoId:string, lang:string){
    this.obtienInfo();
    let datos = {productoId:productoId, lang:lang, user:this.userEmail};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getCultureAudit + this.idEmpresa, datos);
  }

}
